'use client'

import styled from 'styled-components'

import { Accordion } from '@syconium/little-miss-figgy/dist/components/Accordion'
import { TypeStyle } from '@syconium/little-miss-figgy/dist/components/TypeStyle'
import { fromMd } from '@syconium/little-miss-figgy/dist/themes/default/breakpoints'

const StyledWrapper = styled.div<{ $maxWidth?: number | null }>`
  display: flex;
  margin: auto;
  width: 100%;
  max-width: ${o => o.$maxWidth && `${o.$maxWidth}px`};
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
`

type WrapperProps = {
  children?: React.ReactNode
  className?: string
  maxWidth?: number | null
}

export const Wrapper = ({ maxWidth, ...rest }: WrapperProps) => {
  return <StyledWrapper {...rest} $maxWidth={maxWidth} />
}

export const Section = styled(Accordion.Section)``

export const Header = styled(Accordion.Header)<{ $flush?: boolean }>`
  padding: ${o => (o.$flush ? o.theme.spacing(6, 0) : o.theme.spacing(6, 2))};
  ${fromMd} {
    padding: ${o => (o.$flush ? o.theme.spacing(6, 0) : o.theme.spacing(6))};
  }
`

export const Body = styled(Accordion.Body)`
  padding-left: ${o => o.theme.spacing(4)};
  padding-right: ${o => o.theme.spacing(4)};
`

export const Title = styled(TypeStyle.HeadlineExtraExtraSmall)`
  text-align: start;
  font-weight: bold;
`
export const Heading = styled.div`
  margin-bottom: ${o => o.theme.spacing(4)};
  ${fromMd} {
    margin-bottom: ${o => o.theme.spacing(8)};
  }
`
